import { configureStore } from "@reduxjs/toolkit";
import stateReducer from "./features/stateSlice";
import paymentReducer from "./features/paymentSlice";
import availReducer from "./features/availSlice";

export default configureStore({
  reducer: {
    current: stateReducer,
    payment: paymentReducer,
    avails: availReducer,
  },
});
